import { isDevEnv } from 'util/browserUtils';

export default function thunkMiddleware({ dispatch, getState }) {
  return next => action => {
    if (typeof action === 'function') {
      if (isDevEnv()) {
        const name = action.name || 'Anonymous';
        dispatch({ type: 'admin/COMMAND/' + name, _name: name });
      }
      return action(dispatch, getState);
    }
    return next(action);
  };
}



// WEBPACK FOOTER //
// ./src/state/middleware/thunkMiddleware.js